import { ILSAppRegistry } from '../../../../index';

export const getPlanningSettings = () => {
  const currentState = ILSAppRegistry.store.getState();

  return currentState.fixed.Settings.values.planning.parameters;
};

